import { useContext } from "react"
import { Field, useFormikContext } from "formik"
import { FormContext } from "../../context/formContext"
import { InputText as Input } from "primereact/inputtext"
import fieldVisibility from "../../helpers/fieldVisibility"
import { TRIM_TYPES, trimTextValue } from "./helpers/trimTextValue"
import styles from "../../styles/Form.module.css"
import useStaffEmailChecker from "../../hooks/useStaffEmailChecker"

const EMAIL_NOT_UNIQUE_MSG =
  "Email is already connected to a staff membership within the organization."

export default function TypeStaffEmail({ field, block, index }) {
  const form = useContext(FormContext)
  const formikContext = useFormikContext()
  const { checkStaffEmail } = useStaffEmailChecker()

  const allowedToEdit = !(form.idTemplate === "staff" && form.editMode)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled
  isDisabled = !allowedToEdit ? true : isDisabled

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        <span className={styles.asterisk}> *</span>
      </label>
      {field.field_description && allowedToEdit && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      {!allowedToEdit && (
        <div className={styles.description}>
          Account email is controlled by the account holder and can be managed
          in their Account Preferences. Administrators may contact{" "}
          <u>
            <a href="mailto:support@myrecoverylink.com">
              support@myrecoverylink.com
            </a>
          </u>{" "}
          for assistance.
        </div>
      )}
      <div className={styles.value}>
        <Field
          name={field.field_name}
          validate={
            allowedToEdit
              ? async (value) => {
                  if (!value) return undefined
                  const orgId =
                    formikContext.values?.staff_organization_id?.key
                  const selectedStaffId =
                    formikContext.values?.selected_staff_id
                  if (!orgId) return undefined
                  const isUnique = await checkStaffEmail({
                    email: value,
                    selected_staff_id: selectedStaffId || "",
                    organization_id: orgId,
                  })
                  return isUnique ? undefined : EMAIL_NOT_UNIQUE_MSG
                }
              : undefined
          }
        >
          {({ field: formikField, meta, form: formik }) => (
            <span className="p-input-icon-right">
              <Input
                name={formikField.name}
                value={formikField.value}
                onChange={(e) => {
                  formik.setFieldValue(
                    formikField.name,
                    trimTextValue(e, TRIM_TYPES.BOTH).target.value,
                    false,
                  )
                }}
                disabled={isDisabled}
                onBlur={() => {
                  formik.setFieldTouched(formikField.name, true, true)
                }}
                autoComplete="off"
              />
              {meta.touched && meta.error && !formik.isValidating && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </span>
          )}
        </Field>
      </div>
    </div>
  )
}
